// extracted by mini-css-extract-plugin
module.exports = {"radioShadow":"shadow_radioShadow__1hak_","bg":"shadow_bg__2enH-","uploadBtn":"shadow_uploadBtn__3RH8X"};